import React from 'react';
import '../assets/style.css'; // Assuming this contains your global styles

const Footer = () => {
  return (
    <footer className="footer bg-gray-800 text-white py-4 mt-8">
      <div className="container mx-auto text-center">
        <p>&copy; 2026 Stephanie Zolton. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
